import { motion } from 'framer-motion'
import { CreateButton } from '../CreateButton'
import { styles } from './styles'

type CreateCardProps = {
  disableButton?: boolean
  isVisible: boolean
  tooltipMessage?: string
  onClickAdd: () => void
}

/**
 * The "+ Create" affordance rendered inside a category cell on the
 * WeekView grid. Used by both Moment mode (`MomentStack`) and Content
 * mode (`ContentStack`) — the click handler is what determines which
 * creator opens, this component is just the visual entry.
 */
export const CreateCard: React.FC<CreateCardProps> = ({
  disableButton,
  isVisible,
  tooltipMessage,
  onClickAdd,
}) => {
  if (!isVisible) return null

  return (
    // The topmost wrapper div is required because
    // designs has the transparant blue color of the
    // base on a white background
    <motion.div
      animate={{ scale: 1 }}
      css={styles.background}
      initial={{ scale: 0.95 }}
      transition={{
        type: 'spring',
        bounce: 0.5,
        duration: 0.7,
      }}
    >
      <div css={styles.base}>
        <div css={styles.outline}>
          <CreateButton
            disabled={disableButton}
            tooltipMessage={tooltipMessage}
            onClickAdd={onClickAdd}
            styleOverrides={styles.buttonOverrides}
          />
        </div>
      </div>
    </motion.div>
  )
}
